import React, { Fragment } from 'react';
import { Input, Label } from 'reactstrap';
import { ArcaHttpClientPerson } from "../../../code/ArcaHttpClientPerson";
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { PeopleList } from '../../pages/PeopleList';
import { InputField } from '../Fields/InputField';
import { InputLookupButtons } from '../Fields/InputLookupButtons';
import { MapPopup } from '../Mapping/MapPopup';
import { LoginPanel } from '../Security/LoginPanel';
import { StatusBar } from '../StatusBar';
import { PeoplePanelButtons } from './PeoplePanelButtons';

let defaultStatus = 'Registered'

export class PeoplePanel extends ArcaComponent {
    constructor(props) {
        super(props);

        this.state = {
            people: null,
            isLoggedOn: ArcaSecurity.IsLoggedIn,
            mapPopupOpen: false,
            personName: null,
            postcode: null,
            filter: null,
            isSmartphone: ArcaHttpSystem.IsSmartphone,
            status: this.props?.status ?? defaultStatus,
            type: this.props?.type ?? 'Owner',
            searchString: null,
            isLoading: true,
            showLatest: this.props?.showLatest === 'true',
            pageIndex: 0,
        };
    }

    resize() {
        this.setState({
            isSmartphone: ArcaHttpSystem.IsSmartphone
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.getFullList(null, this.state.type, this.state.status, this.state.showLatest, this.state.pageIndex);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    async pageDown() {
        await this.getFullList(
            this.state.searchString,
            this.state.type,
            this.state.status,
            this.state.showLatest,
            this.state.pageIndex + 1
        )
    }

    async pageUp() {

        if (this.state.pageIndex === 0) return

        await this.getFullList(
            this.state.searchString,
            this.state.type,
            this.state.status,
            this.state.showLatest,
            this.state.pageIndex - 1
        )
    }

    async pageTop() {
        await this.getFullList(
            this.state.searchString,
            this.state.type,
            this.state.status,
            this.state.showLatest,
            0
        )
    }


    async getFullList(searchString, type, status, showLatest, pageIndex) {

        ArcaHttpSystem.Log(`searchString = ${searchString}`);
        ArcaHttpSystem.Log(`type = ${type}`);
        ArcaHttpSystem.Log(`status = ${status}`);
        ArcaHttpSystem.Log(`pageIndex = ${pageIndex}`);

        this.setState({ searchString, type, status, showLatest, pageIndex })

        if (type !== null && searchString !== null && searchString !== '') {
            ArcaHttpClientPerson.SearchTypeStatusAsync(searchString,
                type,
                status,
                showLatest,
                pageIndex,
                ((people => this.setState({ people, isError: false, statusText: null, isLoading: false }))),
                ((msg) => this.setState({ isError: false, statusText: `No rows were found (${msg})`, isLoading: false, people:null })),
                ((msg) => this.setState({ isError: true, statusText: msg, isLoading: false }))
            );

            return;
        }

        if (type !== null && ((status === null) || status === undefined)) {
            ArcaHttpClientPerson.GetByTypeAsync(
                type,
                showLatest,
                pageIndex,
                ((people => this.setState({ people, isError: false, statusText: null, isLoading: false }))),
                ((msg) => this.setState({ isError: false, statusText: msg, isLoading: false })));

            return
        }

        if (type === null && status !== null) {
            ArcaHttpClientPerson.GetByStatusAsync(
                status,
                showLatest,
                pageIndex,
                ((people => this.setState({ people, isError: false, statusText: null, isLoading: false }))),
                ((msg) => this.setState({ isError: true, statusText: msg, isLoading: false }))
            );

            return
        }

        ArcaHttpClientPerson.GetByTypeStatusAsync(
            type,
            status,
            showLatest,
            pageIndex,
            ((people => this.setState({ people, isError: false, statusText: null, showLatest }))),
            ((msg) => this.setState({ isError: false, statusText: `No rows were found (${msg})`, isLoading: false, people: null })),
            ((msg) => this.setState({ isError: true, statusText: msg, isLoading: false }))
        );

        // Remember the call for extra page calls.
        this.setState({
            searchString: searchString,
            type: type,
            status: status,
            showLatest: showLatest,
            isLoading: true
        })
    }

    getTypeList(type) {
        this.getFullList(this.state.searchString, type, this.state.status, this.state.showLatest, 0)
    }

    getStatusList(status) {
        this.getFullList(this.state.searchString, this.state.type, status, this.state.showLatest, 0)
    }
    getSearchList(searchString) {
        this.getFullList(searchString, this.state.type, this.state.status, this.state.showLatest, 0)
    }
    reorderList(showLatest) {
        this.getFullList(this.state.searchString, this.state.type, this.state.status, showLatest, 0)
    }

    render() {
        let { isError, statusText, isSmartphone, type, status, searchString, isLoading, people, isLoggedOn, showLatest } = this.state;
        let moreItems = people?.length === 14

        let checked = (showLatest ? "checked" : "")
        ArcaHttpSystem.Log(`show latest (in)->${showLatest} and ${checked}`)
        return (
            <Fragment>

                {people !== null && !isLoggedOn
                    ? <LoginPanel onLogon={(() => this.setState({ isLoggedOn: true }))} />
                    : <Fragment>
                        <h1>{type} - {status}</h1>

                        {ArcaHttpSystem.Log(`searchString='${searchString}'`)}
                        
                        <InputField
                            fieldname='Filter ..'
                            regularExpression='free'
                            warnText='Invalid search text format'
                            mandatory={false}
                            showHeader={false}
                            onUpdate={(
                                (searchString, valid) => {
                                    if (searchString.length > 2)
                                    this.getSearchList(searchString)
                                })}
                            fieldValid={true} />

                        <InputLookupButtons
                            label='Type'
                            fieldname='Type'
                            regularExpression='free'
                            listName='UserType'
                            mandatory={false}
                            value={type}
                            onUpdate={(type) => this.getTypeList(type)} />

                        <InputLookupButtons
                            label='Status'
                            fieldname='Status'
                            regularExpression='free'
                            mandatory={false}
                            listName='UserState'
                            value={status ?? ''}
                            canClear={true}
                            onUpdate={(status) => this.getStatusList(status)} />

                        <PeoplePanelButtons
                            pageIndex={this.state.pageIndex}
                            moreItems={moreItems}
                            pageUp={() => this.pageUp()}
                            pageDown={() => this.pageDown()}
                            pageTop={() => this.pageTop()}
                            reorderList={(str) => this.reorderList(str)}
                        />

                        <StatusBar isError={isError} message={statusText} />

                        <div check className='centerText'>
                            <Label check >
                                {ArcaHttpSystem.Log(`show latest ->${showLatest} and ${checked}`)}
                                <Input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={(e) => {this.reorderList(e.target.checked)}
                                    }
                                />
                                {' Latest'}
                            </Label>
                        </div>
                        <table className='table table-striped' aria-labelledby="tabelLabel">
                            <thead>
                                <tr>
                                    <th>Name</th>

                                    {isSmartphone
                                        ? <th>Postcode</th>
                                        : <th>Address</th>}

                                    {type === 'Owner' ? <th>Pets</th> : null}
                                    {isSmartphone
                                        ? <th></th>
                                        : <th>Login as</th>}
                                </tr>
                            </thead>
                            <tbody>
                                <PeopleList people={people} isLoading={isLoading} type={type} status={status} />
                            </tbody>
                        </table>

                        <PeoplePanelButtons
                            pageIndex={this.state.pageIndex}
                            moreItems={moreItems}
                            pageUp={() => this.pageUp()}
                            pageDown={() => this.pageDown()}
                            pageTop={() => this.pageTop()}
                            reorderList={(str) => this.reorderList(str)}
                        />
                    </Fragment>}

                {
                    this.state.mapPopupOpen
                        ? <MapPopup
                            headerText={"Home of :" + this.state.personName}
                            postcode={this.state.postcode}
                            onClose={(() =>
                                this.setState({ mapPopupOpen: false }))/*.bind(this)*/
                            } />
                        : null
                }
            </Fragment >
        );
    }
}